import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import SignatureCanvas from 'react-signature-canvas';
import axios from 'axios';
import { Alert,Container, Col, Form, Row, FormGroup, FormText , Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AuthorizeRoute from './api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './api-authorization/ApiAuthorizationConstants';
import authService from './api-authorization/AuthorizeService';


import ModalsAlert from './ModalsAlert'
import FileViewer from 'react-file-viewer';
import Tabs from './TabsView';
import Banner from './bannerMensaje';



class solicitudDetail extends React.Component {
  constructor(props) {
    super(props)
      this.state = {
          Id: 0,
          UserId:'',
          ApellidoP: '',
          ApellidoM: '',
          Nombres: '',
          Genero: '',
          lugar_Nacimiento: '',
          Nacionalidad: '',
          Pais_Nacimiento: '',
          RFC_Homoclave: '',
          CURP: '',
          Fecha_Nacimiento: '',
          Num_ident_Oficial_Vigente: '',
          Tipo: '',
          Correo: '',
          hideOtroDestinodelCredito:true,
          hideOtroTypeHousing: true,
          labelTipo: "Clave de Elector*",
          statusEdoCivil: true,
          AddressDetail: '',
          CologneFractionation: '',
          PostalCode: 0,
          NumExt: 0,
          NumInt:'',
          City: '',
          DelegationMunicipality: '',
          State: '',
          Telf_Particular: '',
          Telf_Particular2: '',
          Cellphone: '',
          Telf_Celular2: '',

          NSS: '',
          OfficialIdNumber2: '',
          OfficialIdNumber3:'',

          MaximumDegreeStudies: '',
          MaritalStatus: '',
          SpousalRegime: '',
          NumEconomicDependents: 0,
          FullNameSpouse: '',
          OccupationSpouse: '',
          BusinessSpouse: '',
          CellphoneSpouse: '',
          CompanyPhoneSpouse: '',
          TypeHousing: '',
          Otro: '',
          YearsResidence: 0,
          Empleador: '',
          TipodeEmpleo:'',
          IngresosDeclaradosMensuales: 0,
          FechaIngreso: '',
          MontoSolicitado: 0,
          NumeroParcialidades:0,
          MontoPosibleApagar: 0,
          UsoCredito: '',
          DestinodelCredito: '',
          OtroDestinodelCredito:'',
          NombreCompleto1: '',
          Parentesco1: '',
          TelfLd1: '',
          Telefono1: '',
          TelfExt1: '',
          NombreCompleto2: '',
          Parentesco2: '',
          TelfLd2: '',
          Telefono2: '',
          TelfExt2: '',
          NombreCompleto3: '',
          Parentesco3: '',
          TelfLd3: '',
          Telefono3: '',
        TelfExt3: '',
        Estado: '',
        FechaModificacion: '',
          Firma: '',
          UserIdLogin:'',
          aceptarCondiciones: false,
          Rol: '',
          Comentario: '',
          EstadoModal: '',
          errors: {},
          Avisos: [],
          Catalogo: [],
          bloquearCiudad: 'disabled',
          Sepomex: [],
          StatusCartapoder: true,
          CartaPoder: false,
          aceptarCondiciones: false,
          sigPad : {
              width: 500,
              height: 200,
          },

          trimmedDataURL: null,
          imageFirma: null,
          imagenselfie: false,
          mensajeModal: '',
          modal: false,
          type0: 'png',
          viewer0: '',
     
          UbicacionPersona: '',
          validadorTab1Class: "textoCentrado navActiveButton ActivarMenuItem",
          validadorTab2Class: "textoCentrado navActiveButton ",
          validadorTab3Class: "textoCentrado navActiveButton ",
          validadorTab4Class: "textoCentrado navActiveButton ",
          validadorTab5Class: "textoCentrado navActiveButton ",
          validadorTab6Class: "textoCentrado navActiveButton ",
          validadorTab7Class: "textoCentrado navActiveButton ",
          validadorTab8Class: "textoCentrado navActiveButton ",
          LatitudAPI: '',
          UbicacionAPI: '',
          LongitudAPI: '',
          Intentos: 0,
          FechaVencimiento: '',
          hideinputSMS: true,
          hideTextSMS: false,
          hideBTNinputSMS: false,
          hidetextSMS: true,
          hidevalidateBTN: true,
          hideAprobado: true,
          hideEncurso: false,
          hidebtnEditartelf: true,
          validateTableAlert: true,
          coloniaFrag: '',

        hidePasaporte:true
         
      }


    
    
      this.LLamarModal = this.LLamarModal.bind(this)
this.CerrarModal = this.CerrarModal.bind(this)
    // this.sigPad= React.createRef();
      this.saveFileFromString = this.saveFileFromString.bind(this)
      this.cancelarPantalla = this.cancelarPantalla.bind(this)
      this.UpdateCredito = this.UpdateCredito.bind(this)
      this.handleChange = this.handleChange.bind(this)
      this.SaveValidateFormAdjunto = this.SaveValidateFormAdjunto.bind(this)
      this.displayProcessR = this.displayProcessR.bind(this)
      this.SaveValidateFormfoto = this.SaveValidateFormfoto.bind(this)
      this.refreshBlobListR = this.refreshBlobListR.bind(this)
      this.clear = this.clear.bind(this)
      this.GetDocument = this.GetDocument.bind(this)
      this.trim = this.trim.bind(this);
      this.SaveValidateFormselfie = this.SaveValidateFormselfie.bind(this)
     
  }
    componentDidMount() {
        this.BuscarAviso()

        this.BuscarCatalogo();

        
        this._subscription = authService.subscribe(() => this.populateState2());
        this.populateState2();
        axios.get('GetSaS')
            .then(response => {

                var azure = response.data.split('@')
                window.sas = azure[0];
                window.account = azure[1];
                var validador = window.checkParameters()
                if (validador == true) {
                    window.getBlobService()
                    window.viewContainer(azure[2])
                }
            })
            .catch(function (error) {
                console.log(error);
            })
        //var validador = window.checkParameters()

        //if (validador == true) {
        //    window.getBlobService()
        //    window.viewContainer('maxcapitalmexdocs')


        //}

     

     

    }


    BuscarCatalogo() {

        axios.get('/Api/Settings/GetCatalogo')
            .then(response => {


                this.setState({ Catalogo: response.data });
                console.log(this.state.Catalogo)
                this.BuscarAviso();
            })
            .catch(function (error) {
                console.log(error);
            })


    }

    async populateState2() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        console.log(user)
        this.state.UserIdLogin = user.sub
        
        this.GetUserCurrent();
        console.log(this.props.match.params.id)

        console.log(this.state.UserIdLogin)



      //  window.refreshBlobList(this.state.UserId)
    }

    CerrarModal = () => {

        

        if (this.state.mensajeModal == "No es un usuario valido") {


            this.props.history.push('/')
        } else {
            this.setState({
                modal: false

            })
        }
    }

    modalFirma = () => {

        this.setState({
            mensajeModal: "ModalFirma"

        })

        this.setState({
            modal: true

        })
    }

    LLamarModal = (mensaje) => {
        this.setState({
            mensajeModal: mensaje

        })

        this.setState({
            modal: true

        })
    }
    UpdateCredito(Estado, props) {
        console.log(props)

        if (props.state.Estado == "CONTRATO ANEXADO" || props.state.Estado == "REQUIERE CAMBIOS EN FIRMA O SELFIE") {

            Estado = "EN REVISIÓN FIRMA Y SELFIE"
        }


        const credito = {
            IdSolicitud: parseInt(props.state.Id),
            Estado: this.state.EstadoModal,
            Comentario: this.state.Comentario

        };
       
       
        
        console.log(credito)
        axios.put('/Api/Credito/UpdateStatusCredito/', credito)
            .then(json => {
                console.log(json.data)
               // this.props.history.push('/VerCreditos')

                window.history.back();
            }).catch(function (error) {
                console.log(error);
            })





    }
  cancelarPantalla = () => {
      window.history.back();
  }
    GetUserCurrent = () => {
        console.log(this.props.match.params.id)
        axios.get('/Api/Usuario/UsuarioRole?idEmpleado=' + this.state.UserIdLogin)
        
        .then(response => {
                console.log(response);
            console.log(response.data);
            if (response.data.length>0) {
                this.setState({
                    Rol: response.data[0].role
                })

            }
           
            this.getInfo()
            })
            .catch(function (error) {
                console.log(error);
            })
        //
    }
    
    getInfo = () => {
        console.log('acaaaaaaas')
        axios.get('/Api/Credito/CreditodetailById?id=' + this.props.match.params.id)
            .then(response => {
                console.log(response.data);
            console.log(this.state)
                this.setState({
                    Id: this.props.match.params.id ,
                    ApellidoP: response.data[0].lastName,
                    Nombres: response.data[0].name,
                    ApellidoM: response.data[0].secondLastName,
                    Genero: response.data[0].gender,
                    lugar_Nacimiento: response.data[0].cityofBirth,
                    Nacionalidad: response.data[0].nationality,
                    Pais_Nacimiento: response.data[0].countryofBirth,
                    RFC_Homoclave: response.data[0].rfc,
                    CURP: response.data[0].curp,
                    Cellphone2: response.data[0].cellphone,
                    Num_ident_Oficial_Vigente: response.data[0].officialIdNumber,
                    Tipo: response.data[0].officialIdType,
                    Correo: response.data[0].email,
                    Telf_Particular: response.data[0].phoneNumber,
                    NumeroParcialidades: response.data[0].numeroParcialidades.toString(),
                    MontoPosibleApagar: response.data[0].montoPosibleApagar.toString(),
                    UsoCredito: response.data[0].usoCredito,
                    DestinodelCredito: response.data[0].destinodelCredito,
                    OtroDestinodelCredito: response.data[0].otroDestinodelCredito,
                    Empleador: response.data[0].empleador,
                    TipodeEmpleo: response.data[0].tipodeEmpleo,
                    IngresosDeclaradosMensuales: response.data[0].ingresosDeclaradosMensuales.toString(),
                    FechaIngreso: response.data[0].fechaIngreso,
                    IdSolicitud: response.data[0].IdSolicitud,
                    NombreCompleto1: response.data[0].nombreCompleto1,
                    Parentesco1: response.data[0].parentesco1,
                    TelfLd1: response.data[0].telfLd1,
                    Telefono1: response.data[0].telefono1,
                    TelfExt1: response.data[0].telfExt1,
                    NombreCompleto2: response.data[0].nombreCompleto2,
                    Parentesco2: response.data[0].parentesco2,
                    TelfLd2: response.data[0].telfLd2,
                    Telefono2: response.data[0].telefono2,
                    TelfExt2: response.data[0].telfExt2,
                    NombreCompleto3: response.data[0].nombreCompleto3,
                    Parentesco3: response.data[0].parentesco3,
                    TelfLd3: response.data[0].telfLd3,
                    Telefono3: response.data[0].telefono3,
                    TelfExt3: response.data[0].telfExt3,
                    AddressDetail: response.data[0].addressDetail,
                    CologneFractionation: response.data[0].cologneFractionation,
                    PostalCode: response.data[0].postalCode,
                    NumExt: response.data[0].numExt,
                    NumInt: response.data[0].numInt,
                    City: response.data[0].city,
                    DelegationMunicipality: response.data[0].delegationMunicipality,
                    State: response.data[0].state,
                    MontoSolicitado: response.data[0].montoSolicitado.toString(),
                    TypeHousing: response.data[0].typeHousing,
                    YearsResidence: response.data[0].yearsResidence,
                    MaximumDegreeStudies: response.data[0].maximumDegreeStudies,
                    MaritalStatus: response.data[0].maritalStatus,
                    SpousalRegime: response.data[0].spousalRegime,
                    NumEconomicDependents: response.data[0].numEconomicDependents,
                    FullNameSpouse: response.data[0].fullNameSpouse,
                    OccupationSpouse: response.data[0].occupationSpouse,
                    BusinessSpouse: response.data[0].businessSpouse,
                    CellphoneSpouse: response.data[0].cellphoneSpouse,
                  CompanyPhoneSpouse: response.data[0].companyPhoneSpouse,
                    Estado: response.data[0].estadoCredito,
                    UserId: response.data[0].idUser,
                    Latitud: response.data[0].latitud,
                    Longitud: response.data[0].longitud,
                    Direccion: response.data[0].direccion,
                    NSS: response.data[0].nss,
                    OfficialIdNumber2 :response.data[0].officialIdNumber2,
                    OfficialIdNumber3: response.data[0].officialIdNumber3

                })

                if (this.state.Tipo == "INE/IFE") {

                    this.setState({
                        labelTipo: "Clave de Elector*",
                        hidePasaporte:false
                    })
                } else {

                    this.setState({
                        labelTipo: "Número de Pasaporte*",
                        hidePasaporte: true
                    })
                }
                document.getElementById('LongitudAPI').value = this.state.Latitud

                document.getElementById('LatitudAPI').value = this.state.Longitud

                document.getElementById('UbicacionAPI').value = this.state.Direccion
               


                var Mensaje = "<b>Latitud</b></br>" + this.state.Latitud + "</br>" +
                    "<b>Longitud</b></br>" + this.state.Longitud + "</br>" +
                    //"<b>" + xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[0].nodeName + "</b></br>" + xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[0].textContent + "</br>" +
                    //"<b>" +  xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[1].nodeName + "</b></br>" + xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[1].textContent + "</br>" +
                    //"<b>" +  xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[2].nodeName + "</b></br>" + xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[2].textContent + "</br>" +


                    "<b>Dirección</b></br>" + this.state.Direccion;
                document.getElementById('UbicacionAPIText').innerHTML = Mensaje


                document.getElementById('mapaAPI').src = "https://www.bing.com/maps/embed?h=400&w=500&cp=" + this.state.Latitud + "~" + this.state.Longitud +
                    "&lvl=11&typ=s&sty=r&src=SHELL&FORM=MBEDV8"

                var fecha = response.data[0].dob.split('T')
                var fechaFinal = fecha[0].split('-')
                this.setState({
                    Fecha_Nacimiento: fechaFinal[2] + '-' + fechaFinal[1] + '-' + fechaFinal[0]

                })

                this.BuscarCodigoPostalSEPOMEX()

                if (this.state.Rol == "Admin" || this.state.Rol == "Vendedor" || this.state.Rol == "Analista de Crédito") {

                    if (this.state.Estado == "EN REVISIÓN") {
                        window.refreshBlobList(this.state.UserId, this.state.Id, 5, 0);
                       
                    }
                    else {
                        if (this.state.Estado == "CONTRATO ANEXADO") {
                            window.refreshBlobList(this.state.UserId, this.state.Id, 5, 1);
                        }
                       
                        if (this.state.Estado == "DISPERSADO" || this.state.Estado == "APROBADA"   || this.state.Estado == "EN REVISIÓN FIRMA Y SELFIE" || this.state.Estado == "REQUIERE CAMBIOS EN FIRMA O SELFIE") {
                          
                            window.refreshBlobList(this.state.UserId, this.state.Id, 6, 1);
                            window.refreshBlobList(this.state.UserId, this.state.Id, 5, 1); 
                        }
                    }
                }
                else {

                    if (this.state.UserId !== this.state.UserIdLogin) {
                        //no es el usuario solicitante
                       
                        this.setState({
                            mensajeModal: "No es un usuario valido"

                        })

                        this.setState({
                            modal: true

                        })
                        

                    }
                    var verificarURL;

                    if (this.state.Estado == "CONTRATO ANEXADO" || this.state.Estado == "REQUIERE CAMBIOS EN FIRMA O SELFIE") {
                        window.refreshBlobList(this.state.UserId, this.state.Id, 3, 0);
                        verificarURL = window.refreshBlobList(this.state.UserId, this.state.Id, 6, 0);
                        window.refreshBlobList(this.state.UserId, this.state.Id, 5, 1);

                    }
                    else {
                        
                        if (this.state.Estado == "DISPERSADO") {
                            window.refreshBlobList(this.state.UserId, this.state.Id, 5, 1);
                             window.refreshBlobList(this.state.UserId, this.state.Id, 6, 1);
                        }
                    }

                }
                
                if (this.state.DestinodelCredito == "OTRO") {

                    this.setState({ ['hideOtroDestinodelCredito']: false })
                }
                else {

                    this.setState({ ['hideOtroDestinodelCredito']: true })

                }

                if (this.state.TypeHousing == "OTRO") {

                    this.setState({ ['hideOtroTypeHousing']: false })
                }
                else {

                    this.setState({ ['hideOtroTypeHousing']: true })

                } 

                if (this.state.MaritalStatus == "CASADO/A") {

                          this.setState({ ['statusEdoCivil']: false })
                }
                else {

                          this.setState({ ['statusEdoCivil']: true })

                } 

                window.refreshBlobList(this.state.UserId, this.state.Id, 0, 1);
                window.refreshBlobList(this.state.UserId, this.state.Id, 9, 1);
                window.refreshBlobList(this.state.UserId, this.state.Id, 1, 1);
                window.refreshBlobList(this.state.UserId, this.state.Id, 2, 1);
                window.refreshBlobList(this.state.UserId, this.state.Id, 3, 1);
                window.refreshBlobList(this.state.UserId, this.state.Id, 4, 1);
                window.refreshBlobList(this.state.UserId, this.state.Id, 8, 1);
                window.getFirma(this.state.UserId + "/" + this.state.Id + "/7/Firma")
              
                //this.cambiarColonia()

               // alert(document.getElementById("adjunto6").getAttribute("href"))
                this.GetDocument(this)
                this.f1()
            })
            .catch(function (error) {
                console.log(error);
            })
        
        
    }



    BuscarCodigoPostalSEPOMEX() {
        if (this.state.PostalCode == "") {


        } else {
            axios.get('/Api/Settings/Sepomex?id=' + this.state.PostalCode)
                .then(response => {
                    console.log(response.data)


                    this.setState({ Sepomex: response.data });

                    this.setState({ State: response.data[0].dEstado })
                    this.setState({ DelegationMunicipality: response.data[0].dMnpio })

                    if (response.data[0].dCiudad == "" || response.data[0].dCiudad == null || response.data[0].dCiudad == "null") {
                        this.setState({ bloquearCiudad: '' })
                       
                    } else {
                        this.setState({ bloquearCiudad: 'disabled' })
                        this.setState({ City: response.data[0].dCiudad })
                    }


                    console.log(response.data)

                    console.log(document.querySelectorAll('.intent10').length)
                    if (document.querySelectorAll('.intent10').length > 0) {
                        this.setState({ CartaPoder: true });
                        this.setState({ ['StatusCartapoder']: false })

                    }


                })
                .catch(function (error) {
                    console.log(error);
                })

        }
    }


    BuscarAviso() {

        axios.get('/Api/Settings/GetAvisos')
            .then(response => {


                this.setState({ Avisos: response.data });
                console.log(this.state.Avisos)

            })
            .catch(function (error) {
                console.log(error);
            })


    }

    async f1() {
        var x = await this.resolveAfter2Seconds(10);
        console.log(x); // 10
        var valor = x.split("?")
        this.setState({ viewer0: valor[0] })
        console.log(this.state)

        //FileViewer.open(valor).then(() => {
        //    console.log('success');
        //}).catch(error => {
        //        console.log(error);
        //    })
               }

   resolveAfter2Seconds() {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve(window.file0);
        }, 2000);
    });
}
    ValidateForm = () => {
      //  e.preventDefault();
        let error = {};
        let validador = true;
        this.setState({ errors: {} });
        //if (this.state.Fecha_Nacimiento == "") {
        //    error["Error_Fecha_Nacimiento"] = "Debe seleccionar una fecha valida.";
        //    this.setState({ errors: error });
        //    validador = false;
        //} 
        if (this.state.FechaIngreso == "") {
            error["Error_FechaIngreso"] = "Debe seleccionar una fecha valida.";
            this.setState({ errors: error });
            validador = false;
        }

        if (validador) {
            this.setState({ errors: {} });
            console.log('validation successful')
            console.log(this.state)
            this.addCredito();

            
        } else {
           // alert('Por favor, verifique el formulario')
        }
     
    }
    addCredito = () => {

        const solicitud = {
            Id: parseInt(0),
            UserId: this.state.UserId
        };
        const credito = {
            IdSolicitud: 0,
            MontoSolicitado:parseFloat(this.state.MontoSolicitado.toString()),
            NumeroParcialidades: parseFloat(this.state.NumeroParcialidades.toString()),
            MontoPosibleApagar: parseFloat(this.state.MontoPosibleApagar.toString()),
          UsoCredito: this.state.UsoCredito,
               Estado: this.state.Estado
        };

        const laboral = {
            IdSolicitud: 0,
            Empleador: this.state.Empleador,
            TipodeEmpleo: this.state.TipodeEmpleo,
            IngresosDeclaradosMensuales: parseFloat(this.state.IngresosDeclaradosMensuales.toString()),
            FechaIngreso: this.state.FechaIngreso
        };

        const referencias = {
            IdSolicitud: 0,
            NombreCompleto1: this.state.NombreCompleto1,
            Parentesco1: this.state.Parentesco1,
            TelfLd1: this.state.TelfLd1,
            Telefono1: this.state.Telefono1,
            TelfExt1: this.state.TelfExt1,
            NombreCompleto2: this.state.NombreCompleto2,
            Parentesco2: this.state.Parentesco2,
            TelfLd2: this.state.TelfLd2,
            Telefono2: this.state.Telefono2,
            TelfExt2: this.state.TelfExt2,
            NombreCompleto3: this.state.NombreCompleto3,
            Parentesco3: this.state.Parentesco3,
            TelfLd3: this.state.TelfLd3,
            Telefono3: this.state.Telefono3,
            TelfExt3: this.state.TelfExt3,
        };
        const obj = {
            solicitud: solicitud,
            credito: credito,
            laboral: laboral,
            referencias: referencias
        }
        console.log(obj)
        //carga de la solicitud
        axios.post('/Api/Credito/AddSolicitud/', obj).then(json => {
            console.log(json.data)
            if (json.data.status === 'Success') {
                console.log(json.data.Message);
                obj.credito.IdSolicitud = json.data.Message;

               




            }
        
        }).catch(error => {
            console.log(error.response)
        });

      

  }
    handleChange = (e) => {
    //    this.ValidateForm();
        console.log(e)
        e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
    }

    onUpdateEstadoFail = (val) => {
        console.log(val)
        this.setState({
            EstadoModal: val
        })

        console.log(this.state)
    };
    onUpdate = (val) => {
        console.log(val)
        this.setState({
            Comentario: val
        })

        console.log(this.state)
    };

    onActualizar = (val,Estado) => {
        console.log(val)
        console.log(Estado)
       this.UpdateCredito(Estado, val)
    }

    SaveValidateFormAdjunto = () => {

        window.uploadBlobByStream(false, this.state.UserId, 5, this.state.Id)
    }
    SaveValidateFormselfie = () => {

        window.uploadBlobByStream(false, this.state.UserId, 6, this.state.Id)
    }

    SaveValidateFormCarta = () => {
        console.log("/////////////////////////")
        window.uploadBlobByStream(false, this.state.UserId, 3, this.state.Id)
    }
    saveFileFromString = ()  => {
        console.log(this.state.trimmedDataURL)
        window.uploadBlobFromText(this.state.UserId + "/" + this.state.Id + "/7/Firma", this.state.trimmedDataURL)
       
      
    }
    GetDocument = (modalValue) => {

        console.log("/////////////////////////" + document.getElementById("adjunto7"))
        console.log("/////////////////////////" + document.getElementById("imagenFirmaGet").src)

       
        window.getFirma(modalValue.state.UserId + "/" + modalValue.state.Id + "/7/Firma");

       
       
    }

    SaveValidateFormfoto = () => {

        window.uploadBlobByStream(false, this.state.UserId, 6, this.state.Id)
    }
    displayProcessR = () => {

        window.displayProcess(0)
    }
    refreshBlobListR = () => {
        console.log("acas")
      
    }
    //sigPad = {
    //    width: 500,
    //    height: 200,
    //};
    handleChangeFirma = () => {
        //    this.ValidateForm();
   
       
      //  this.setState({ [e.target.name]: e.target.value });
    }
    trim = (modalValue) => {


        this.setState({
            trimmedDataURL: modalValue.state.sigPad.getTrimmedCanvas()
                .toDataURL('image/png')
        })
        console.log(this.state)

        



        console.log(modalValue)
        console.log(modalValue.state.trimmedDataURL)
        window.uploadBlobFromText(this.state.UserId + "/" + this.state.Id + "/7/Firma", modalValue.state.sigPad.getTrimmedCanvas().toDataURL('image/png'))

      
    }
    clear = (modalValue) => {
        modalValue.state.sigPad.clear()
    }
  render() {
      
     console.log(this.state)
      var Option3;
      if (this.state.Rol !== "Admin") {

          if (this.state.Estado == "Contrato anexado") {
              Option3 = <div><input type="file" id="files3" name="file3" onClick={this.displayProcessR} accept=".jpg,.png,.jpeg,.bmp,.pdf" />
                  <button type="button" id="upload-button3" value="3" className="btn btn-info" onClick={this.SaveValidateFormCarta}>Subir</button>
                  <Alert color="success" id="UploadAlert3" className="alertHide">
                      This is a success alert — check it out!
                              </Alert>
                  <Alert color="danger" id="UploadFailAlert3" className="alertHide">
                      This is a danger alert — check it out!
                              </Alert>
              </div>;
              
          }
          else {
              Option3 = "";
          }


      }
      
      //<FileViewer
      //    fileType={this.state.type0}
      //    filePath={this.state.viewer0}

      //    errorComponent={e => console.log(e)}
      ///>
     
    return (
        <Container className="App">

            <Form className="form">


                <img src="/images/Logo-color-max-capital-mex-300x59.png" className="print-only" alt="Max Capital Mex" />
                <h2 className="PageHeading" >Solicitud  de crédito</h2>

                
                <Banner state={this.state}

                />
                <br />
                <Tabs state={this.state} handleChangehidestatusEdoCivil={this.handleChangehidestatusEdoCivil}
                    handleChangehideOtroTypeHousing={this.handleChangehideOtroTypeHousing}
                    handleChangeDestinodelCredito={this.handleChangeDestinodelCredito}
                    handleChangeTabs={this.handleChangeTabs}
                    handleChangePostalCode={this.handleChangePostalCode}
                    handleChangeMontoPosibleApagar={this.handleChangeMontoPosibleApagar}
                    SaveValidateFormAdjunto={this.SaveValidateFormAdjunto}
                    displayProcessR={this.displayProcessR}
                    handleCheck={this.handleCheck}
                    handleCheckCartaPoder={this.handleCheckCartaPoder}
                    ValidateForm={this.ValidateForm}
                    SaveValidateForm={this.SaveValidateForm}
                    cancelarPantalla={this.cancelarPantalla}
                    UbicarPesona={this.UbicarPesona}
                    AlertaInfoUbicacion={this.AlertaInfoUbicacion}
                    modalFirma={this.modalFirma}
                    LLamarModal={this.LLamarModal} 
                    onUpdate={this.onUpdate}
                    onActualizar={this.onActualizar}
                    onUpdateEstadoFail={this.onUpdateEstadoFail}
                    SaveValidateFormCarta={this.SaveValidateFormCarta}
                    GetDocument={this.GetDocument} saveFileFromString={this.saveFileFromString} sigPad={this.state.sigPad} trim={this.trim} clear={this.clear}
                    SaveValidateFormfoto={this.SaveValidateFormfoto} refreshBlobListR={this.refreshBlobListR}
                    displayProcessR={this.displayProcessR} SaveValidateFormselfie={this.SaveValidateFormselfie} handleChange={this.handleChange}
                    SaveValidateFormAdjunto={this.SaveValidateFormAdjunto}
                />  


       

                <ModalsAlert state={this.state} CerrarModal={this.CerrarModal} isOpen={this.state.modal} />
            </Form>
        </Container>
    );
  }
}
export default solicitudDetail;


//<AccionesBTN state={this.state} cancelarPantalla={this.cancelarPantalla} UpdateCredito={this.UpdateCredito} /> 
             